import { QueryCache, QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      // Only log errors for background refetches and failed retries
      // Don't log every error to avoid noise
      if (query.state.dataUpdatedAt === 0) {
        console.error('Query failed:', error, query.queryKey)
      } else {
        console.warn('Background query failed:', error, query.queryKey)
      }
    },
  }),
  defaultOptions: {
    queries: {
      // Enable smart retry logic
      retry: (failureCount, error) => {
        // FUTURE TODO: Should use error.response.status, but need to parse for a ResponseError object instead of an Error object
        // Don't retry on 4xx errors (client errors)
        if (error instanceof Error && error.message.includes('400'))
          return false
        if (error instanceof Error && error.message.includes('401'))
          return false
        if (error instanceof Error && error.message.includes('403'))
          return false
        if (error instanceof Error && error.message.includes('404'))
          return false

        // Retry up to 3 times for other errors (network, 5xx, etc.)
        return failureCount < 3
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),

      // Set appropriate cache timing
      staleTime: 5 * 60 * 1000, // 5 minutes - data is considered fresh for 5 minutes
      gcTime: 30 * 60 * 1000, // 30 minutes - unused data is garbage collected after 30 minutes

      // Enable background refetching for better UX
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      refetchOnMount: true,

      // Prevent unnecessary background refetches during rapid navigation
      refetchInterval: false,
    },
    mutations: {
      // Enable retry for mutations on network errors only
      retry: (failureCount, error) => {
        // Only retry on network errors, not application errors
        if (error instanceof Error) {
          const isNetworkError =
            error.message.includes('Network Error') ||
            error.message.includes('fetch') ||
            error.message.includes('Failed to fetch') ||
            error.message.includes('NetworkError')
          return isNetworkError && failureCount < 2
        }
        return false
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 5000),
      onError: (error, variables, context) => {
        console.error('Mutation failed:', error, { variables, context })
      },
    },
  },
})
